module.exports = __webpack_public_path__ + "pic/13.6d6a0e4f.png";